import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { SettingsTabBar } from "@/pages/settings/components/tab-bar";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import {
  MDSText,
  MDSTextVariant,
  MDSPanelHeader,
  MDSPanelHeaderSlotName,
  MDSPanelContainer,
  MDSSeparator,
} from "@/mds";
import { FeatureGateBanner } from "@/components/banners/feature-gate-banner/feature-gate-banner";

interface SettingsGeneralPageProps {
  children: React.ReactNode;
}

export const SettingsLayout: FC<SettingsGeneralPageProps> = observer(({ children }) => {
  const { pageStore } = useAppStore();
  const page = pageStore.settingsPage;
  page.useSettingsPageParams();

  return (
    <>
      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          numberOfLines={1}
        >
          Settings
        </MDSText>
      </MDSPanelHeader>
      <FeatureGateBanner />
      <Wrapper>
        <Container>
          <SettingsTabBar sections={page.tabBarSections} selectedItemId={page.selectedTabId} />
          <StyledVerticalDivider orientation="vertical" />
          <ContentContainer>{children}</ContentContainer>
        </Container>
      </Wrapper>
    </>
  );
});

const Wrapper = styled.div({
  height: "100%",
  maxHeight: "100%",
  overflowY: "scroll",
  scrollbarWidth: "none",
});

const Container = styled(MDSPanelContainer)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: `${theme.spacing[4]} ${theme.spacing[3]} 0 0`,
  flex: "1 0 0",

  "@container mds-panel (max-width: 750px)": {
    flexDirection: "column",
    height: "auto",
    gap: theme.spacing[2],
    paddingRight: 0,
  },
}));

const ContentContainer = styled.div({
  height: "100%",
  width: "100%",
  scrollbarWidth: "none",
});

const StyledVerticalDivider = styled(MDSSeparator)({
  marginLeft: 0,
  "@container mds-panel (max-width: 750px)": {
    display: "none",
  },
});
